import workspaceQuery from '../../queries/bank/BankWorkspaceQuery.graphql';
import listQuery from '../../queries/bank/BankListQuery.graphql';
import instanceQuery from '../../queries/bank/BankQuery.graphql';
import defaultQuery from '../../queries/bank/BankDefault.graphql';
import mutationQuery from '../../mutations/bank/BankMutation.graphql';
import aggregateQuery from '../../queries/bank/BankAggregateQuery.graphql';
import fragment from '../../fragments/bank/BankFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Bank: EntityType = {
  type: 'Bank',
  title: 'Bank Accounts',
  formTitle: 'Bank Account',
  formUrl: '/Bank/Bank/Details/',
  workspaceUrl: '/Bank/Bank/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'BANK_ACCOUNTS',
  actions: [
    {
      description: 'Reconcile',
      actionReference: 'BANK_RECONCILIATION_CREATE',
    },
    {
      description: 'Reconciled Balance',
      actionReference: 'BANK_RECONCILIATION_CREATE',
    },
  ],
};

export default Bank;
